// History-API router with scroll restoration. Links are ordinary <a href>
// elements; clicks on same-origin links are intercepted here.

const routes = [];
let onRoute = () => {};
let current = null;

export function route(pattern, name) {
  const keys = [];
  const re = new RegExp(
    `^${pattern.replace(/\/:([a-z]+)/g, (_, k) => {
      keys.push(k);
      return '/([^/]+)';
    })}/?$`,
  );
  routes.push({ re, keys, name, pattern });
}

export function match(path) {
  for (const r of routes) {
    const m = r.re.exec(path);
    if (m) {
      const params = {};
      r.keys.forEach((k, i) => {
        params[k] = decodeURIComponent(m[i + 1]);
      });
      return { name: r.name, params };
    }
  }
  return { name: 'notfound', params: {} };
}

function saveScroll() {
  try {
    history.replaceState({ ...(history.state || {}), scrollY: window.scrollY }, '');
  } catch {
    // Losing one scroll position is harmless.
  }
}

export function currentRoute() {
  return current;
}

export function navigate(to, { replace = false } = {}) {
  const url = new URL(to, location.origin);
  if (url.origin !== location.origin) {
    location.href = to;
    return;
  }
  const path = url.pathname + url.search + url.hash;
  if (replace) {
    history.replaceState({ inApp: !!(history.state && history.state.inApp) }, '', path);
  } else {
    saveScroll();
    history.pushState({ inApp: true }, '', path);
  }
  dispatch({ restoreScroll: false, direction: replace ? 'replace' : 'forward' });
}

// Go back within the app if there is somewhere to go back to; otherwise
// (deep link, fresh tab) go to a sensible parent instead of leaving the site.
export function back(fallback = '/') {
  if (history.state && history.state.inApp) history.back();
  else navigate(fallback, { replace: true });
}

function dispatch({ restoreScroll, direction }) {
  const url = new URL(location.href);
  const m = match(url.pathname);
  current = { ...m, path: url.pathname, query: url.searchParams, hash: url.hash };
  const y = restoreScroll && history.state && typeof history.state.scrollY === 'number' ? history.state.scrollY : 0;
  onRoute(current, { scrollY: y, direction });
}

export function start(handler) {
  onRoute = handler;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download') || 'external' in a.dataset) return;
    const href = a.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//') || href.startsWith('/api/')) return;
    e.preventDefault();
    navigate(href, { replace: 'replace' in a.dataset });
  });
  window.addEventListener('popstate', () => dispatch({ restoreScroll: true, direction: 'back' }));
  dispatch({ restoreScroll: true, direction: 'none' });
}
